// Collapses consecutive <br> and paragraph tags produced by rich-text editors into single elements
const formatHTML = (htmlResponse: string) => {
  return htmlResponse
    .replaceAll('<br><br>', '<br>')
    .replaceAll('<p><br></p>\n<p><br>', '<p><br></p>');
};

export default formatHTML;
